import React from 'react'
import { useNavigate } from 'react-router-dom';
import { explore } from '../../routes/route';
const { EXPLORE_MANAGEMENT, USER_ACTIVITY_LOG } = explore;
const Explore = () => {
  const navigate = useNavigate();
    return (
        <div className="container min-vh-100 d-flex justify-content-center align-items-center">
          <div className="row text-center">
            <div className="col-12 mb-4">
              <h1 className="display-4">Explore Management</h1>
              <p className="lead">Choose an option to proceed</p>
            </div>
            <div className="col-md-6 mb-3 block_user_button">
              <button 
                className="btn-lg w-100 py-3" style={{padding: '10px 20px'}}
                onClick={() => navigate(EXPLORE_MANAGEMENT)}
              >
                Manage Explore
              </button>
            </div>
            <div className="col-md-6 mb-3">
              <button 
                className="btn btn-secondary btn_secondary_btn btn-lg w-100 py-3"
                style={{fontSize: '16px'}}
                onClick={() => navigate(USER_ACTIVITY_LOG) }
              >
                User Activity Log
              </button>
            </div>
          </div>
        </div>
      );
}

export default Explore
